import { render, staticRenderFns } from "./lookPlatform.vue?vue&type=template&id=4641a8fe&scoped=true"
import script from "./lookPlatform.vue?vue&type=script&lang=js"
export * from "./lookPlatform.vue?vue&type=script&lang=js"
import style0 from "./lookPlatform.vue?vue&type=style&index=0&id=4641a8fe&lang=scss"
import style1 from "./lookPlatform.vue?vue&type=style&index=1&id=4641a8fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641a8fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4641a8fe')) {
      api.createRecord('4641a8fe', component.options)
    } else {
      api.reload('4641a8fe', component.options)
    }
    module.hot.accept("./lookPlatform.vue?vue&type=template&id=4641a8fe&scoped=true", function () {
      api.rerender('4641a8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/lookPlatform.vue"
export default component.exports